import { render, staticRenderFns } from "./OrderMovementsList.vue?vue&type=template&id=3ab8d411"
import script from "./OrderMovementsList.vue?vue&type=script&lang=js"
export * from "./OrderMovementsList.vue?vue&type=script&lang=js"
import style0 from "./OrderMovementsList.vue?vue&type=style&index=0&id=3ab8d411&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports